module.exports = __webpack_public_path__ + "img/GU.e0acd649.png";